var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 24.9991C40 25.4963 39.8025 25.9732 39.4509 26.3248C39.0993 26.6764 38.6224 26.8739 38.1252 26.8739L16.4039 26.8739L24.4542 34.9205C24.8063 35.2725 25.004 35.75 25.004 36.2478C25.004 36.7457 24.8063 37.2232 24.4542 37.5752C24.1022 37.9272 23.6247 38.125 23.1269 38.125C22.629 38.125 22.1516 37.9272 21.7995 37.5752L10.5508 26.3264C10.3762 26.1523 10.2377 25.9454 10.1432 25.7176C10.0487 25.4899 10 25.2457 10 24.9991C10 24.7525 10.0487 24.5083 10.1432 24.2806C10.2377 24.0528 10.3762 23.8459 10.5508 23.6717L21.7995 12.423C22.1516 12.071 22.629 11.8732 23.1269 11.8732C23.6247 11.8732 24.1022 12.071 24.4542 12.423C24.8063 12.775 25.004 13.2525 25.004 13.7504C25.004 14.2482 24.8063 14.7257 24.4542 15.0777L16.4039 23.1243L38.1252 23.1243C38.6224 23.1243 39.0993 23.3218 39.4509 23.6734C39.8025 24.025 40 24.5019 40 24.9991Z",
    fill: "#3A3A3A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.55e5607c2e64ba55e3fb5bebd337bf1e.svg";
export { ForwardRef as ReactComponent };